import React, { useCallback, useEffect, useMemo, useRef, useState, useContext } from "react";
import Form from "../../components/Form";
import { connect } from "react-redux";
import Labels from "../../services/apiLabels";
import {
  OFFICE_TIMING,
  APPOINTMENT_CREATE,
  SELL_MY_CAR_STEPS,
  APPOINTMENT_UPDATE,
  TOASTER_SHOW,
  toaster_w,
} from "../../constant";
import { GET, POST } from "../../constant/apiMethods";
import Dropdown from "../../components/Form/Dropdown";
import { getTimeSolts, formateTimeSlot } from "../../utils/formating";
import { scrollTop } from "../../utils/window";
import { useDispatch, useSelector } from "react-redux";
import FeedbackContext from "../../context/cmscontext";
import { HiOutlineLocationMarker } from "react-icons/hi";
import {
  buildSchedulerDays,
  buildSelectionFromAppointment,
  findOfficeForAppointment,
  formatOfficeLocationLabel,
  getBookedAppointmentRecord,
  getOfficeAddress,
  getOfficeCompanyName,
} from "../../utils/appointmentBooking";
import {
  enrichOfficesWithDealerCompanies,
} from "../../utils/dealerCompanies";
import { getAuthCredits } from "../../utils/userIdentity";

function normalizeOfficeList(value) {
  if (Array.isArray(value)) return value;
  if (Array.isArray(value?.results)) return value.results;
  if (Array.isArray(value?.data)) return value.data;
  if (Array.isArray(value?.offices)) return value.offices;
  return [];
}

function SellMyCarstep4(props) {
  const { feedback } = useContext(FeedbackContext);
  const evaluation_page = feedback.evaluation_page || {};
  const {
    evaluation,
    getOfficeTiming,
    officetiming,
    loading_officetiming,
    loading_appointment_create,
    appointment_create,
    office,
    time_selected,
    setoffice,
    settime_selected_slot,
    settime_selected,
    settime_selected_reset,
    formanimationClassname,
    name,
    appointmentId,
    updateIndex,
  } = props;
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const isUpdate = name === "update";
  const typeConstant = isUpdate ? APPOINTMENT_UPDATE : APPOINTMENT_CREATE;
  const bookedAppointment = getBookedAppointmentRecord(
    evaluation,
    appointment_create
  );
  const hydratedRef = useRef(false);
  const [timedata, set_timedata] = useState([]);
  const [officesWithCompanies, setOfficesWithCompanies] = useState([]);
  const officeList = useMemo(
    () => normalizeOfficeList(officetiming),
    [officetiming]
  );
  const officeHasTiming =
    office?.timming && Object.values(office.timming).length > 0;

  const formatOfficeOptionLabel = useCallback(
    (item) => item?.displayLabel || formatOfficeLocationLabel(item),
    []
  );

  const initializeSchedulerSelection = () => {
    const schedulerDays = buildSchedulerDays(office);
    set_timedata(schedulerDays);

    if (!schedulerDays.length) {
      return;
    }

    const first = schedulerDays[0];
    settime_selected({
      ...first,
      date: first.dateNum,
      id: first.dayId,
      day_formated: `${first.day}, ${first.date}`,
    });
    settime_selected_slot("");
  };

  useEffect(() => {
    getOfficeTiming();
  }, [getOfficeTiming]);

  useEffect(() => {
    let cancelled = false;

    enrichOfficesWithDealerCompanies(officeList, auth).then((enriched) => {
      if (!cancelled) {
        setOfficesWithCompanies(enriched);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [officeList, auth]);

  const officeOptions = useMemo(
    () => (officesWithCompanies.length > 0 ? officesWithCompanies : officeList),
    [officesWithCompanies, officeList]
  );

  useEffect(() => {
    if (loading_officetiming || !Array.isArray(officeOptions) || !officeOptions.length) {
      return;
    }
    if (officeHasTiming) {
      return;
    }

    const matched = findOfficeForAppointment(officeOptions, {
      office: office?.id,
      office_id: office?.id,
      Address: office?.address,
    });

    if (matched) {
      setoffice(matched);
    }
  }, [
    loading_officetiming,
    officeOptions,
    office?.id,
    office?.address,
    officeHasTiming,
    setoffice,
  ]);

  useEffect(() => {
    if (!isUpdate || hydratedRef.current || loading_officetiming) {
      return;
    }
    if (!Array.isArray(officeOptions) || officeOptions.length === 0) {
      return;
    }
    if (!bookedAppointment) {
      return;
    }

    const matchedOffice =
      findOfficeForAppointment(officeOptions, bookedAppointment) ||
      (office?.address
        ? findOfficeForAppointment(officeOptions, {
            Address: office.address,
            office: office.id,
          })
        : null);

    if (!matchedOffice) {
      return;
    }

    if (String(office.id) !== String(matchedOffice.id)) {
      setoffice(matchedOffice);
    }

    const { schedulerDays, selection, slot } = buildSelectionFromAppointment(
      matchedOffice,
      bookedAppointment
    );
    set_timedata(schedulerDays);

    if (selection) {
      settime_selected(selection);
      if (slot) {
        settime_selected_slot(slot);
      }
    }

    hydratedRef.current = true;
  }, [
    isUpdate,
    loading_officetiming,
    officeOptions,
    bookedAppointment,
    office?.address,
    office?.id,
    setoffice,
    settime_selected,
    settime_selected_slot,
  ]);

  // Keep selected office company_name when dealer enrichment finishes.
  useEffect(() => {
    if (!office?.id || !Array.isArray(officesWithCompanies) || !officesWithCompanies.length) {
      return;
    }
    if (getOfficeCompanyName(office)) {
      return;
    }
    const matched = officesWithCompanies.find(
      (item) => String(item.id) === String(office.id)
    );
    if (matched && getOfficeCompanyName(matched)) {
      setoffice({ ...office, ...matched });
    }
  }, [officesWithCompanies, office, setoffice]);

  useEffect(() => {
    if (!officeHasTiming) {
      return;
    }

    const hasSelection =
      Boolean(time_selected.slot) ||
      (Boolean(time_selected.date) && Boolean(time_selected.day_formated));

    if (hasSelection) {
      if (!timedata.length) {
        set_timedata(buildSchedulerDays(office));
      }
      return;
    }

    if (!isUpdate) {
      initializeSchedulerSelection();
    }
  }, [office, isUpdate, time_selected, timedata.length, officeHasTiming]);

  const isTodaySelected = () => {
    if (!time_selected?.date) {
      return false;
    }

    const date = new Date();
    const dateSelectedArr = time_selected.date.split("-");
    const dateSelected = +dateSelectedArr[dateSelectedArr.length - 1];
    return dateSelected === date.getDate();
  };

  const renderTimeSlots = () => {
    const { start, end } = office.timming[time_selected.day_index] || {};
    const slots = getTimeSolts(start, end, isTodaySelected());

    if (slots.length > 0) {
      return slots.map((item, index) => {
        const isSelected = time_selected.slot == item;

        return (
          <button
            type="button"
            key={index}
            className={`pi-book-appointment__slot-btn ${
              isSelected ? "is-selected" : ""
            }`}
            onClick={() => settime_selected_slot(item)}
          >
            {formateTimeSlot(item)}
          </button>
        );
      });
    }

    return (
      <div className="pi-book-appointment__slots-empty">
        No time slots available for this day
      </div>
    );
  };

  const postAppointmentCreateHandler = () => {
    if (!isUpdate) {
      const credits = Number(getAuthCredits(auth));
      if (!Number.isFinite(credits) || credits <= 0) {
        dispatch({
          type: TOASTER_SHOW,
          payload: {
            show: true,
            autoHide: true,
            type: toaster_w,
            heading: "No credits",
            description:
              "You have 0 credits. Please top up your credits before booking an appointment.",
          },
        });
        return;
      }
    }

    const data = {
      evaluation: evaluation.id,
      office: office.id,
      time_selected: time_selected.slot,
      date_selected: time_selected.date,
      date_applied: time_selected.date,
      updateIndex,
    };

    if (isUpdate && appointmentId) {
      data.appointment = appointmentId;
    }

    if (
      (data.evaluation || appointmentId) &&
      data.office &&
      data.time_selected &&
      time_selected.date
    ) {
      dispatch({
        type: typeConstant,
        payload: {
          type: typeConstant,
          method: POST,
          label:
            isUpdate && appointmentId
              ? Labels.appointment_update + appointmentId
              : Labels.appointment_create,
          hideOverlayLoader: true,
          data,
        },
      });
      // Wait for API success before thank-you / completion state.
      scrollTop();
      return;
    }

    const missing = [];
    if (!data.office) missing.push("inspection centre");
    if (!time_selected.date) missing.push("date");
    if (!data.time_selected) missing.push("time slot");
    dispatch({
      type: TOASTER_SHOW,
      payload: {
        show: true,
        autoHide: true,
        type: toaster_w,
        heading: "Almost there",
        description: missing.length
          ? `Please select ${missing.join(", ")} before confirming.`
          : "Please complete centre, date, and time before confirming.",
      },
    });
  };

  const setofficeHandler = (item) => {
    setoffice(item);
    settime_selected_reset();
    set_timedata(buildSchedulerDays(item));
  };

  const currentBookingLabel = bookedAppointment
    ? [
        formatOfficeLocationLabel(bookedAppointment) ||
          formatOfficeLocationLabel(office),
        bookedAppointment.date_selected || bookedAppointment.date_applied,
        bookedAppointment.time_selected
          ? formateTimeSlot(bookedAppointment.time_selected)
          : null,
      ]
        .filter(Boolean)
        .join(" · ")
    : "";

  const selectedOfficeAddress = getOfficeAddress(office);
  const selectedOfficeCompany = getOfficeCompanyName(office);

  return (
    <div
      className={`pi-book-appointment__form${
        isUpdate ? " pi-book-appointment__form--compact" : ""
      }`}
    >
      <Form
        width="fluid"
        onSubmit={postAppointmentCreateHandler}
        buttonText={
          isUpdate
            ? evaluation_page.Update_appointment_button_text || "Save appointment"
            : evaluation_page.Get_your_appointment_button_text || "Confirm appointment"
        }
        className={`pi-book-appointment__form-inner ${formanimationClassname || ""}`}
        childClassName="pi-book-appointment__fields"
        loading={loading_appointment_create}
        loadingText={
          isUpdate
            ? evaluation_page.Update_appointment_button_loading ||
              "Updating your appointment…"
            : evaluation_page.Get_your_appointment_button_loading ||
              "Booking your appointment…"
        }
        buttonClassName="pi-evaluation__submit-btn"
      >
        {isUpdate && currentBookingLabel ? (
          <div className="pi-book-appointment__current-booking" aria-live="polite">
            <span className="pi-book-appointment__current-booking-label">
              Current booking
            </span>
            <span className="pi-book-appointment__current-booking-value">
              {currentBookingLabel}
            </span>
          </div>
        ) : null}

        <Dropdown
          label={evaluation_page.Office_label || "Inspection centre"}
          onSelect={setofficeHandler}
          selectedValue={office}
          loading={loading_officetiming}
          disabled={loading_officetiming}
          data={officeOptions}
          titleKey="address"
          formatLabel={formatOfficeOptionLabel}
          dropdownClassName="pi-form-dropdown pi-appointment-edit__office-dropdown"
          listHeight={360}
        />

        {selectedOfficeAddress ? (
          <div className="pi-book-appointment__office-meta" aria-live="polite">
            <HiOutlineLocationMarker size={16} aria-hidden />
            <div className="pi-book-appointment__office-meta-copy">
              <span className="pi-book-appointment__office-meta-address">
                {selectedOfficeAddress}
              </span>
              {selectedOfficeCompany ? (
                <span className="pi-book-appointment__office-meta-company">
                  {selectedOfficeCompany}
                </span>
              ) : null}
            </div>
          </div>
        ) : null}

        {!loading_officetiming && Array.isArray(officeOptions) && officeOptions.length === 0 ? (
          <p className="pi-book-appointment__empty-hint">
            No inspection centres are available right now. Please try again shortly.
          </p>
        ) : null}

        {officeHasTiming ? (
          <>
            <div className={`pi-book-appointment__field ${formanimationClassname || ""}`}>
              <label className="pi-book-appointment__field-label">
                {evaluation_page.Appointment_Time_label || "Selected time"}
              </label>
              <div className="pi-book-appointment__selected-time">
                <HiOutlineLocationMarker size={16} aria-hidden />
                <span>
                  {time_selected.day_formated ||
                    "Select a day from the list, then choose a time slot"}
                  {time_selected.slot
                    ? ` · ${formateTimeSlot(time_selected.slot)}`
                    : ""}
                </span>
              </div>
            </div>

            <div
              className={`pi-book-appointment__scheduler ${formanimationClassname || ""}`}
            >
              <div className="pi-book-appointment__days" aria-label="Available days">
                {timedata.map((item, dayIndex) =>
                  item ? (
                    <button
                      type="button"
                      key={dayIndex}
                      className={`pi-book-appointment__day-btn ${
                        time_selected.day_index === item.day_index ? "is-selected" : ""
                      }`}
                      onClick={() => {
                        settime_selected({
                          ...item,
                          date: item.dateNum,
                          day_formated: `${item.day}, ${item.date}`,
                        });
                        settime_selected_slot("");
                      }}
                    >
                      <span className="pi-book-appointment__day-name">{item.day}</span>
                      <span className="pi-book-appointment__day-date">{item.date}</span>
                    </button>
                  ) : null
                )}
              </div>
              <div className="pi-book-appointment__slots" aria-label="Available time slots">
                {office.address ? renderTimeSlots() : null}
              </div>
            </div>
          </>
        ) : null}
      </Form>
    </div>
  );
}

const mapStateToProps = (state) => ({
  evaluation: state.sellMyCar.evaluation_create,
  loading_officetiming: state.sellMyCar.loading_officetiming,
  officetiming: state.sellMyCar.officetiming,
  appointment_create: state.sellMyCar.appointment_create,
  office: state.sellMyCar.step4.office,
  time_selected: state.sellMyCar.step4.time_selected,
  loading_appointment_create: state.sellMyCar.loading_appointment_create,
});

const mapDispatchToProps = (dispatch) => ({
  setoffice: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "office",
        data,
      },
    }),
  settime_selected_slot: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "time_selected_slot",
        data,
      },
    }),
  settime_selected: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "time_selected",
        data,
      },
    }),
  settime_selected_reset: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: {
        type: "time_selected_reset",
        data,
      },
    }),
  getOfficeTiming: () =>
    dispatch({
      type: OFFICE_TIMING,
      payload: {
        type: OFFICE_TIMING,
        method: GET,
        label: `${Labels.officetiming}`,
        hideOverlayLoader: true,
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(SellMyCarstep4);
